import React from "react";
import Footer from "../Footer";
import Header from "./Header";
import { Link } from "react-router-dom";

function Gallery() {
  document.title='HR School - Gallery'
  return (
    <div>
        <Header/>
      <center>
        {" "}
        <br />
        <br />
        <Link to="/allpicture">
          <img src="images/news/n-1.jpg" alt="News" />
        </Link>
      </center> <br /><br /><br />
      <Footer/>
    </div>
  );
}

export default Gallery;
